import axios from 'lib/axios'

function updateVM({ patchData, updateVMTableData, vm }) {
  let path
  switch (vm._type) {
    case 'VcenterVMAsset':
      path = `/assets/vcenter/vms/${vm.id}`
      break;
    case 'HyperVVMAsset':
      path = `/assets/hyper_v/vms/${vm.id}`
      break;
  }

  axios.patch(path, { vm: patchData })
    .then((_) => {
      axios.get(`/assets/cloudcore/compliance/${vm.id}`)
        .then((response) => updateVMTableData(response.data))
    })
}

export { updateVM }
